export default "/_nuxt/a57fc814de42c0ce69f1167d6c7102e6.svg";